<template>
  <div>
    <div class="layout-segment">
      <div
        class="layout-segment__header"
        :data-title="items[1].tytul"
        :data-url="items[1].linkb"
      >
        <h2 class="layout-segment__title">{{ items[1].tytul }}</h2>
        <a
          class="layout-segment__more-link"
          :title="items[1].tytul"
          :href="items[1].linkb"
          >wszystkie oferty</a
        >
      </div>

      <template v-if="oferty.length == 0">
        <T1PromoOffersPlaceholder />
      </template>
      <template v-else>
        <template v-if="window.width < 992">
          <div v-if="oferty" class="promo-offers-wrapper">
            <splide :slides="oferty" :options="promoOptions">
              <splide-slide v-for="(item, idx) in oferty" :key="idx">
                <T1PromoOfferCard :oferta="getOfertyItems(idx)" />
              </splide-slide>
            </splide>
          </div>
        </template>
        <template v-else>
          <a-row v-if="oferty" :gutter="[24, 24]">
            <a-col :md="12" v-for="(item, idx) in oferty" :key="idx">
              <T1PromoOfferCard :oferta="getOfertyItems(idx)" />
            </a-col>
          </a-row>
        </template>
      </template>
    </div>

    <div class="layout-segment">
      <div
        class="layout-segment__header"
        :data-title="items[2].tytul"
        :data-url="items[2].linkb"
      >
        <h2 class="layout-segment__title">{{ items[2].tytul }}</h2>
        <a
          class="layout-segment__more-link"
          :title="items[2].tytul"
          :href="items[2].linkb"
          >wszystkie oferty</a
        >
      </div>

      <template v-if="allinclusive.length == 0">
        <T1PromoOffersPlaceholder />
      </template>
      <template v-else>
        <template v-if="window.width < 992">
          <div v-if="allinclusive" class="promo-offers-wrapper">
            <splide :slides="allinclusive" :options="promoOptions">
              <splide-slide v-for="(item, idx) in allinclusive" :key="idx">
                <T1PromoOfferCard :oferta="getAllInclusiveItems(idx)" />
              </splide-slide>
            </splide>
          </div>
        </template>
        <template v-else>
          <a-row v-if="allinclusive" :gutter="[24, 24]">
            <a-col :md="12" v-for="(item, idx) in allinclusive" :key="idx">
              <T1PromoOfferCard :oferta="getAllInclusiveItems(idx)" />
            </a-col>
          </a-row>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import T1PromoOffersPlaceholder from "./T1Placeholders/T1PromoOffersPlaceholder";
import T1PromoOfferCard from "./T1OfferCards/T1PromoOfferCard";
import { frontlinki } from "./frontlinki.js";
import * as CONFIG from "./config.js";

axios.defaults.withCredentials = false;

export default {
  data: () => ({
    url: "/getoferty.json",
    dparams: frontlinki.items[1].link.split("?").pop(),
    lparams: frontlinki.items[2].link.split("?").pop(),
    oferty: [],
    allinclusive: [],
    items: frontlinki.items,
    promoOptions: {
      arrows: false,
      destroy: true,
      breakpoints: {
        991: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        479: {
          perPage: 1,
        },
      },
      gap: "8px",
    },
    window: {
      width: 0,
    },
  }),
  methods: {
    getOferty(typ) {
      //alert("PARAMS:" + this.dparams);
      var pars = this.dparams;
      if (typ == "allinc") {
        pars = this.lparams;
      }
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);
               alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOfertyItems(i) {
      return this.oferty[i];
    },
    getAllInclusiveItems(i) {
      return this.allinclusive[i];
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
  },
  mounted() {
    this.getOferty("oferty").then((data) => {
      //alert("OFERTY:" + JSON.stringify(data.page.response));
      this.oferty = data.page.response;
    }),
      this.getOferty("allinc").then((data) => {
        //alert('OFERTY:' + JSON.stringify(data.page.response));
        this.allinclusive = data.page.response;
      });
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
  components: {
    T1PromoOffersPlaceholder,
    T1PromoOfferCard,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .promo-offers-wrapper {
  position: relative;
  margin-left: -8px;
  margin-right: -8px;

  .splide {
    &__slide {
      padding: 8px;
    }

    &__pagination {
      bottom: -24px;
    }

    &__pagination__page {
      margin: 4px;

      &.is-active {
        background-color: $blue-light;
        opacity: 1;
        transform: none;
      }
    }
  }
}
</style>
